import { TrendsTypes } from './trends.action';

const INITIAL_STATE = {
  list: [],
  isFetching: false,
  error: false,
  errors: [],

  page: [],
  paging: {
    error: false,
    errors: [],
    fetching: false,
    offset: 0,
    page: 1,
    limit: 30,
    totalItems: 0,
    maxPage: 0,
  },

  filters: [],
  filtersLoading: false,
};

const onFetching = (state) => ({ ...state, isFetching: true, errors: [] });

const onError = (state, action) => {
  const { errors } = action.payload;
  return {
    ...state,
    error: true,
    errors,
    isFetching: false,
  };
};

const onGetReceive = (state, action) => {
  const { list } = action.payload;

  return {
    ...state,
    list,
    isFetching: false,
    error: false,
    errors: [],
  };
};

const onPageError = (state, action) => {
  const { errors } = action.payload;
  const { paging } = state;
  return {
    ...state,
    paging: {
      ...paging,
      error: true,
      errors,
    },
  };
};

const onPageFetch = (state) => {
  const { paging } = state;

  return {
    ...state,
    paging: {
      ...paging,
      fetching: true,
      error: false,
      errors: [],
    },
  };
};

const onPageReceive = (state, action) => {
  const oldPaging = state.paging;
  const { page, paging } = action.payload;

  return {
    ...state,
    page,
    paging: {
      ...oldPaging,
      fetching: false,
      error: false,
      errors: [],
      ...paging,
    },
  };
};

const onFiltersError = (state) => ({ ...state, filtersLoading: false });

const onFilterFetch = (state) => ({ ...state, filtersLoading: true });

const onFilterReceive = (state, action) => {
  const { filters } = action.payload;

  return {
    ...state,
    filters,
    filtersLoading: false,
  };
};

const trendsReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TrendsTypes.FETCH: return onFetching(state);
    case TrendsTypes.ERROR: return onError(state, action);
    case TrendsTypes.GET_RECEIVE: return onGetReceive(state, action);
    case TrendsTypes.PAGE_ERROR: return onPageError(state, action);
    case TrendsTypes.PAGE_FETCH: return onPageFetch(state, action);
    case TrendsTypes.PAGE_RECEIVE: return onPageReceive(state, action);
    case TrendsTypes.FILTERS_ERROR: return onFiltersError(state, action);
    case TrendsTypes.FILTERS_FETCH: return onFilterFetch(state, action);
    case TrendsTypes.FILTERS_RECEIVE: return onFilterReceive(state, action);
    default: return state;
  }
};

export default trendsReducers;
